import React from 'react';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import useSnack from 'hooks/useSnack';

const { FormItem } = Form;

const AddCollege = ({ form, college, onClose, onSave }) => {
  const snack = useSnack();
  const { getFieldDecorator, validateFields } = form;

  const onSubmit = () => {
    return validateFields().then((values) => {
      return onSave(values).then(
        () => {
          snack.success('College added');
          onClose();
        },
        (e) => snack.error(e.message),
      );
    });
  };

  return (
    <Drawer open anchor="right">
      <Box width={500} p={2}>
        <Typography paragraph variant="subtitle1">
          {college ? 'Edit College' : 'Add College'}
        </Typography>
        <Form>
          <FormItem>
            {getFieldDecorator('id', {
              initialValue: college?.id,
              rules: [{ required: true }],
            })(<Input label="College ID" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('name', {
              initialValue: college?.name,
              rules: [{ required: true }],
            })(<Input label="Name" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('website_url', {
              initialValue: college?.website_url,
              rules: [{ required: true }],
            })(<Input label="Webisite URL" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('deadline_url', {
              initialValue: college?.deadline_url,
              rules: [{ required: true }],
            })(<Input label="Deadline URL" />)}
          </FormItem>
          <Box textAlign="right">
            <Button onClick={onClose}>Cancel</Button>{' '}
            <Button variant="contained" color="primary" onClick={onSubmit}>
              Save
            </Button>
          </Box>
        </Form>
      </Box>
    </Drawer>
  );
};

export default Form.create()(AddCollege);
